/* eslint-disable global-require, import/extensions */
// ES6 module wrapper/entry point for the React version
if (process.env.NODE_ENV === 'production') {
  module.exports = require('../dist/custom-form-client-react-umd.min.js');
} else {
  module.exports = require('../dist/custom-form-client-react.js');
}
